// extracted by mini-css-extract-plugin
export default {"wrapper":"Gallery_wrapper__-Ho8i","gallery":"Gallery_gallery__9nEup","preview":"Gallery_preview__a6pSQ"};